import { Component, OnInit, ViewChild } from '@angular/core';
import { Compra } from 'src/app/Models/compra/compra/compra';
import { Usuario } from 'src/app/Models/usuario/usuario';
import { AuthService } from 'src/app/Service/auth.service';
import { DataService } from 'src/app/Service/data.service';
import { NotifyService } from 'src/app/Service/notify.service';
import { InfoComponent } from '../../objects/info/info/info.component';
import { LoadingComponent } from '../../objects/loading/loading.component';
import { NothingComponent } from '../../objects/nothing/nothing.component';
import { AlertComponent } from '../../objects/alert/alert/alert.component';
import { DetalleCompra } from 'src/app/Models/compra/detallecompra/detalle-compra';

@Component({
  selector: 'app-compras-detalles-informes',
  templateUrl: './compras-detalles-informes.component.html',
  styleUrls: ['./compras-detalles-informes.component.css']
})
export class ComprasDetallesInformesComponent implements OnInit {
  @ViewChild(AlertComponent, null) alert: AlertComponent;
  @ViewChild(LoadingComponent, null) loading: LoadingComponent;
  @ViewChild(NothingComponent, null) public nothing: NothingComponent;
  @ViewChild(InfoComponent, null) info: InfoComponent;
  public usuario:Usuario=new Usuario();
  public detcompras:DetalleCompra[] = [];
  public sumacantidad:number = 0;
  public sumapreuni:number = 0;
  public sumatotal:number = 0;
  constructor(private data: DataService, private notify: NotifyService,private auth:AuthService) { }

  ngOnInit() {
    this.usuario = this.auth.getCurrentUser();
    this.GetData();
  }

  GetData(){
    this.loading.show('cargando datos');
    this.data.GetSimple(this.data.api.detcompra).subscribe(r => {
      if (r.length < 1) {
          console.log(r);
          this.detcompras=[];
      }else{
          console.log(r);
          this.detcompras=r;
          console.log("Resultado");
          console.log(this.detcompras);
          this.loading.hide();
      }
    }, e => { console.log(e); },()=>this.GetTotalVentas());
  }

  GetTotalVentas(){
    this.sumacantidad = 0;
    this.sumapreuni = 0;
    this.sumatotal = 0;

    this.detcompras.forEach(detalle => {
      this.sumacantidad+= +detalle.cantidad
      this.sumapreuni+= +detalle.precio
      this.sumatotal+= +detalle.subtotal1
    });

    // console.log(this.sumacantidad);
    // console.log(this.sumapreuni);
    // console.log(this.sumatotal);

  }
}
